import axios from '@/api/http';
import base from '@/api//base';
const goods = {
	// 分页请求所有数据-商品
	GoodsPage(params){
		return axios.post(`${base.baseURL}/Goods/page`,params);
	},
	// 新增数据-商品
	GoodsInsert(params){
		return axios.post(`${base.baseURL}/Goods/insert`,params);
	},
	// 修改数据-商品
	GoodsUpdate(params){
		return axios.post(`${base.baseURL}/Goods/update`,params);
	},
	// 删除数据-商品
	GoodsDeleteById(id){
		return axios.post(`${base.baseURL}/Goods/delete/${id}`);
	},
	// 上传文件
	loadFile(file) {
		return axios.post(`${base.baseURL}/SysFile/upload`,file)
	},
}
export default goods;



// WEBPACK FOOTER //
// ./src/network/goods.js